<template>
	<div id="intro" class="container">
		<br>
		<el-row class="pad-container">
			<div class="pad-inner-container">
				<el-col v-for="category in content" :span="12" :key="category.slug">
					<div class="pad">
						<div class="image" >
							<img :src="'/static/img/' + category.icon" />
						</div>
						<router-link :to="'/' + category.slug" class="link"></router-link>
					</div>
				</el-col>
			</div>
		</el-row>
	</div>
</template>

<script>
	export default {
		name: 'home',
		data() {
			return {
				pos: 0
			}
		},
		created () {
			this.$store.commit( 'ON_NEUTRAL_PAGE' )
			if ( !this.$store.getters.isBootstraped ){
				this.$store.dispatch( 'bootstrap' )
			}
		},
		computed: {
			content () {
				return this.$store.state.content
			}
		}
	}
</script>

<style lang="less">

	#intro{
		position: relative;
		height: ~"calc(100% - 215px)";

		.pad-container{
			height: 100%;
			overflow-y: scroll;
			-webkit-overflow-scrolling: touch;
		}

		.el-col{
			background-color: #E82537;
			border-bottom: 2px solid #F2F2F2;
			border-left: 1px solid #F2F2F2;
			border-right: 1px solid #F2F2F2;
		}

		.pad{
			position: relative;
			display: table;
			width: 100%;
			height: 261px;
			color: white;

			.image{
				display: table-cell;
				vertical-align: middle;
			}

			.link{
				position: absolute;
				width: 100%;
				height: 100%;
				top: 0;
				right: 0;
				bottom: 0;
				left: 0;	
			}
		}
	}
</style>



// WEBPACK FOOTER //
// Home.vue?2ea24b7c